/**
 * Divento Academy — 1:30762.
 *
 * Editorial content only. The page is a pre-launch notice: there is nothing
 * account-specific on it and no endpoint behind it, so everything below is
 * copy rather than a fixture standing in for data.
 *
 * NEEDS AN ENDPOINT: the "Notify me" form has nowhere to post. See the note in
 * Divento.jsx — it validates the address and then stops, rather than claiming
 * to have signed anyone up.
 */

export const HERO = {
  brand: 'Divento Academy',
  chip: 'Coming soon',
  /** Two lines in the design; the break is deliberate, not a wrap. */
  titleLines: ['Advanced Diploma in', 'Financial Trading'],
  note:
    'Trading is easy to start. Hard to master. Six weeks of structured video ' +
    'courses take you from your first chart to funded-account strategies, and ' +
    'every completed week earns a verified certificate on your Alpha Capital ' +
    'profile.',
  cta: 'Notify me',
  placeholder: 'Enter your email',
  small: 'We will email you the moment the first week goes live. No other mail, ever.',
};

/** The two cards under the hero. `icon` names a component in Divento.jsx. */
export const BLOCKS = [
  {
    id: 'courses',
    icon: 'course',
    value: '120+',
    tag: 'Video courses',
    stats: ['6 weeks', '124 lessons', '15h+ video'],
    copy:
      'Learning paths from your first chart to funded-account strategies. ' +
      'Short lessons, real market examples, progress tracked per account.',
  },
  {
    id: 'certificates',
    icon: 'certificate',
    value: 'Certificates',
    tag: 'Verified on completion',
    stats: ['Pass assessment', 'Shareable link', 'Profile linked'],
    copy:
      'Finish a course, pass its assessment, earn a verified certificate — ' +
      'shareable and linked to your Alpha Capital profile.',
  },
];
